import { useQuery } from 'react-query';

import { getSharedResourcesForOverlappingActivities as queryFn } from 'api/endPoints/getSharedResourcesForOverlappingActivities';

import { ISharedResourcesAvailabilityResponse } from 'components/widgets/Gantt/components/ganttChart.types';

export const useSharedResourcesAvailability = (params) => {
    return useQuery<ISharedResourcesAvailabilityResponse, QueryError>(
        ['sharedResourcesAvailability', params],
        () => queryFn(params),
        {
            enabled: Boolean(params.lastMetaDataId),
        },
    );
};
